import React, { useState, useEffect, useRef } from "react";
import CssTransition from "../../../component/layout/css-transition";
import InputField from "../../../component/input-field";
import CreatableSelect from "react-select/creatable";
import { requestget, requestpost } from "../../../service/request";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../component/modal-popup/customeModal";

// New Rich text editor
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { shareActivity } from "./shareActivityTemplate";
import "../../../css/theme.css";

// Redux
import { useSelector } from "react-redux";

function EmbeddedShareModal({
  modalOpen,
  setModalOpen,
  tableinfo,
  company_id,
  tableColumn,
  tableData,
  customeFields,
}) {
  const { userDetails } = useSelector((state) => state.user);

  const [userData, setUserData] = useState();
  const [data, setData] = useState();
  let width = window.screen.width;

  /* --------------- Integrting API's ------------------- */
  const getUserbyCompanyId = async () => {
    try {
      const response = await requestget(`/user/company`);
      if (!response.results) {
        throw "Something went wrong";
      }
      setUserData(response.results);
    } catch (error) {
      console.log(error);
    }
  };

  // Calling get user API function
  useEffect(() => {
    getUserbyCompanyId();
  }, []);

  // Get Share Template Data for rich textbox
  useEffect(() => {
    setData(
      shareActivity(
        tableColumn?.slice(0, tableColumn.length - 1),
        tableData,
        customeFields,
        userDetails.company_name,
        userDetails.name,
        userDetails.team_name
      ).toString()
    );
  }, [tableColumn, tableData]);

  /*----------------------------- Dynamic Option creation ------------------------------------ */
  const createOption = (label) => ({
    label,
    value: label,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState();
  const [validation, setValidation] = useState(false);
  const [ccValidation, setCcValidation] = useState(false);

  // Creating state to store payload data.
  const [ccData, setCcData] = useState([]);
  const [toData, setToData] = useState([]);
  const [subject, setSubject] = useState("");

  // Creating state for validation
  const [toValidation, settoValidation] = useState(false);
  const [subjectValidation, setSubjectValidation] = useState(false);

  /* --------------- Setting Options -----------------*/
  const userList = [];
  useEffect(() => {
    if (userData) {
      userData.forEach((user) => {
        const obj = {
          label: user.name,
          value: user.email,
        };
        userList.push(obj);
      });
      setOptions(userList);
    }
  }, [userData]);

  const handleCreateForTo = (inputValue, index) => {
    setIsLoading(true);
    setTimeout(() => {
      const newOption = createOption(inputValue);
      setIsLoading(false);
      setOptions((prev) => [...prev, newOption]);
      setToData((prev) => [...prev, newOption]);
    }, 1000);
  };

  const handleCreateForCC = (inputValue, index) => {
    setIsLoading(true);
    setTimeout(() => {
      const newOption = createOption(inputValue);
      setIsLoading(false);
      setOptions((prev) => [...prev, newOption]);
      setCcData([...ccData, newOption]);
    }, 1000);
  };

  /*----------------- Document Attachement part ---------------------------*/
  const documentArr = [];
  const [documentName, setDocumentName] = useState([]);
  const [isCancelClick, setIsCancelClick] = useState(1);

  const addDocument = () => {
    if (tableinfo?.activity_performances) {
      setDocumentName(
        tableinfo.activity_performances.filter(
          (item) => item.file_name !== null && item.file_name !== ""
        )
      );
    }
  };

  // Calling addDoument function
  useEffect(() => {
    addDocument();
  }, [tableinfo, isCancelClick]);

  // Removing element for array.
  const removeDocument = (element) => {
    setDocumentName((prev) => {
      return prev.filter((item) => item !== element);
    });
  };

  function clearData() {
    setCcData([]);
    setToData([]);
    setSubject("");
  }

  const handleSend = async () => {
    try {
      if (toData.length === 0) {
        settoValidation(true);
        return null;
      }

      if (!subject) {
        setSubjectValidation(true);
        return null;
      }

      const payloadTO = [];
      const payloadCC = [];
      const payloadFile = [];

      toData.map((item) => {
        payloadTO.push(item[Object.keys(item)[1]]);
      });

      if (ccData.length > 0) {
        ccData.map((item) => {
          payloadCC.push(item[Object.keys(item)[1]]);
        });
      }

      documentName.map((item) => {
        const obj = {
          file_name: item.file_name,
          file_path: item.file_path,
        };
        payloadFile.push(obj);
      });

      const payload = {
        to: payloadTO,
        cc: payloadCC,
        subject: subject,
        message: data,
        files: payloadFile,
      };

      const response = await requestpost(
        "/activityperformance/share",
        JSON.stringify(payload)
      );
      if (!response.data) {
        throw "Something went wrong";
      }
      setModalOpen(!modalOpen);
      swal({
        content: (
          <CustomeModal
            type="success"
            title="Success!"
            content={`Email send successfully.`}
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
      setSubjectValidation(false);
      settoValidation(false);
      clearData();
    } catch (error) {
      swal({
        content: (
          <CustomeModal
            type="error"
            title="Error!"
            content={`Something went wrong. Please try again later.`}
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
    }
  };

  // react-draftjs changes

  const getContent = (htmlData) => {
    setData(htmlData);
  };

  // Jodit-react HTML editor
  const editor = useRef(null);

  const config = {
    readonly: false, // all options from https://xdsoft.net/jodit/doc/,
    placeholder: "Write message here",
    allowTabNavigation: true,
    // askBeforePasteFromWord: true,
    autofocus: true,
  };

  return (
    <div
      onClick={(e) => {
        if (e.target.id === "modal5" || e.target.id === "modal6") {
          setModalOpen(false);
        }
      }}
    >
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={modalOpen}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
        id="modal5"
      />
      <CssTransition
        className="fixed inset-0 z-50 flex items-center my-4 justify-center px-4 sm:px-6 overflow-y-auto"
        role="dialog"
        aria-modal="true"
        show={modalOpen}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
        id="modal6"
      >
        <div className="bg-white overflow-auto max-w-3xl h-full w-full max-h-max rounded shadow-lg flex flex-col">
          <div className="space-y-2">
            <div className="flex justify-between items-center space-x-2 m-3">
              <p>To</p>
              <div className="w-10/12">
                <CreatableSelect
                  isMulti
                  // isClearable
                  isDisabled={isLoading}
                  isLoading={isLoading}
                  className={`min-w-60 sm:min-w-0 unresetText ${
                    toValidation && toData.length === 0
                      ? "border border-rose-500"
                      : ""
                  }`}
                  onChange={(newValue) => {
                    setToData(newValue);
                  }}
                  onCreateOption={(inputValue) => {
                    const re = /\S+@\S+\.\S+/g;
                    if (re.test(inputValue)) {
                      handleCreateForTo(inputValue);
                      setValidation(false);
                    } else {
                      setValidation(true);
                    }
                  }}
                  options={options}
                  value={toData}
                  placeholder=""
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                />
                {validation && (
                  <p className="text-xs text-rose-500">Enter valid E-mail</p>
                )}
                {toValidation && toData.length === 0 && (
                  <p className="text-xs text-rose-500">
                    Please specify at least one recipient.
                  </p>
                )}
              </div>
            </div>
            <div className="flex justify-between items-center space-x-2 m-3">
              <p>CC</p>
              <div className="w-10/12">
                <CreatableSelect
                  isMulti
                  // isClearable
                  isDisabled={isLoading}
                  isLoading={isLoading}
                  className="min-w-60 sm:min-w-0 unresetText"
                  onChange={(newValue) => {
                    setCcData(newValue);
                  }}
                  onCreateOption={(inputValue) => {
                    const re = /\S+@\S+\.\S+/g;
                    if (re.test(inputValue)) {
                      handleCreateForCC(inputValue);
                      setCcValidation(false);
                    } else {
                      setCcValidation(true);
                    }
                  }}
                  options={options}
                  value={ccData}
                  placeholder=""
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                />
                {ccValidation && (
                  <p className="text-xs text-rose-500">Enter valid E-mail</p>
                )}
              </div>
            </div>
            <div className="flex justify-between items-center space-x-2 m-3">
              <p>Subject</p>
              <div className="w-10/12">
                <InputField
                  type="text"
                  value={subject}
                  onChange={(event) => {
                    setSubject(event.target.value);
                  }}
                  error={
                    subjectValidation && !subject
                      ? "Subject cannot be empty."
                      : null
                  }
                />
              </div>
            </div>
            {/* <div className="m-3">
                <JoditEditor
                  ref={editor}
                  value={content}
                  config={config}
                  tabIndex={1} // tabIndex of textarea
                  onChange={(newContent) => {
                    console.log("newContent ----", newContent);
                    setContent(newContent);
                  }}
                />
              </div> */}
            <div className="m-3">
              {/* <TextEditor getContent={getContent} /> */}
              <CKEditor
                editor={ClassicEditor}
                data={data}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  getContent(data);
                }}
                onReady={(editor) => {
                  console.log(
                    "editor.ui.view.editable.element.style.minHeight",
                    editor.ui.view.editable.element.style
                  );
                  editor.ui.view.editable.element.style.height = "200px";
                }}
              />
            </div>
          </div>
          <div className="m-3 flex space-x-2">
            {documentName.map((item, index) => {
              return (
                <div className="bg-blue-200 p-1 w-auto rounded-md flex items-center justify-betweenm space-x-3">
                  <p className="text-slate-500 text-sm">{item.file_name}</p>
                  <div className="flex items-center justify-end">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      className="w-5 h-5 fill-current shrink-0 mr-2 text-slate-500 cursor-pointer"
                      onClick={(e) => {
                        removeDocument(item);
                      }}
                    >
                      <path d="M175 175C184.4 165.7 199.6 165.7 208.1 175L255.1 222.1L303 175C312.4 165.7 327.6 165.7 336.1 175C346.3 184.4 346.3 199.6 336.1 208.1L289.9 255.1L336.1 303C346.3 312.4 346.3 327.6 336.1 336.1C327.6 346.3 312.4 346.3 303 336.1L255.1 289.9L208.1 336.1C199.6 346.3 184.4 346.3 175 336.1C165.7 327.6 165.7 312.4 175 303L222.1 255.1L175 208.1C165.7 199.6 165.7 184.4 175 175V175zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z" />
                    </svg>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="flex flex-wrap justify-center space-x-2 p-2">
            <button
              className="btn-sm !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white cursor-pointer"
              onClick={(e) => {
                handleSend();
              }}
            >
              Send
            </button>
            <button
              className="btn-sm border bg-orange-400 text-white cursor-pointer"
              onClick={(e) => {
                setModalOpen(!modalOpen);
                setIsCancelClick(isCancelClick + 1);
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </CssTransition>
    </div>
  );
}

export default EmbeddedShareModal;
